import request from '@/utils/request'

// 查询企业微信-客户标签列表
export function listExternalUserTag(query) {
    return request({
        url: '/wxCp/externalUserTag/list',
        method: 'get',
        params: query
    })
}

// 查询企业微信-客户标签详细
export function getExternalUserTag(id) {
    return request({
        url: '/wxCp/externalUserTag/' + id,
        method: 'get'
    })
}

// 新增企业微信-客户标签
export function addExternalUserTag(data) {
    return request({
        url: '/wxCp/externalUserTag',
        method: 'post',
        data: data
    })
}

export function RefreshCP_ExternalUserTagList(data) {
    return request({
        url: '/wxCp/externalUserTag/RefreshCP_ExternalUserTagList',
        method: 'post',
        data: data
    })
}



// 修改企业微信-客户标签
export function updateExternalUserTag(data) {
    return request({
        url: '/wxCp/externalUserTag/update',
        method: 'post',
        data: data
    })
}

// 删除企业微信-客户标签
export function delExternalUserTag(id) {
    return request({
        url: '/wxCp/externalUserTag/delete/' + id,
        method: 'post'
    })
}
